module.exports = __webpack_public_path__ + "static/media/md-chatboxes.91b10fb5.svg";